import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'

/* ------- MICROFRONT - FARMI APP APPRO ------- */

export const farmiAppApproRoutes = [
  {
    path: '/farmi/app/appro/categories',
    name: 'farmi-app-appro-categories',
    beforeEnter(_, __, next) {
      if (!isWebViewFarmi()) {
        next({ name: 'home' })
      } else {
        microFrontListener({
          iframe: { href: window.location.origin },
          analyticService: useAnalyticService(),
        })
        next()
      }
    },
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'categories',
    }),
  },
  {
    path: '/farmi/app/appro/chatbot',
    name: 'farmi-app-appro-chatbot',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'chatbot',
    }),
  },
]
